import React from "react";
import { Chips } from "primereact/chips";
import { InputText } from "primereact/inputtext";
import "./Form.scss";


const TagInput = ({ value, onChange }) => {
    return (
        <div className="tag-input-container">
            <Chips
                value={value}
                onChange={(e) => onChange(e.value)}
                placeholder="Enter Tags"
                className="form-input"
            />
        </div>
    );
};

export default TagInput;
